import { DeleteButton } from "@refinedev/antd";
import { useAnalytics } from "hooks/useAnalytics/";
import { BrandKitAsset } from "pages/media/types/";
import { errorNotificationWithEntityIdsHandler } from "pages/onboarding/helpers/";
import { AnalyticsEvents } from "types/analytics/";

export const DeleteAssetControl = ({
  organizationId,
  brandkitId,
  asset,
  onDeleteSuccess,
}: {
  organizationId: string;
  brandkitId: string;
  asset: Partial<BrandKitAsset>;
  onDeleteSuccess: (assetId: string) => void;
}) => {
  const { trackEvent } = useAnalytics();
  return (
    <DeleteButton
      accessControl={{ enabled: false }}
      hideText
      recordItemId={asset.asset_id}
      resource={`media/${organizationId}/brand_kits/${brandkitId}/assets`}
      onSuccess={() => {
        trackEvent(AnalyticsEvents.BrandKitAssetDelete, {
          brandkit_id: brandkitId,
          asset_id: asset?.asset_id,
          asset_type: asset?.type,
        });
        // do not invalidate the brandkit now to not lose unsaved changes (colors, etc)
        onDeleteSuccess?.(asset?.asset_id);
      }}
      errorNotification={(error) => {
        const result = errorNotificationWithEntityIdsHandler(
          error,
          "project_ids"
        );
        return result;
      }}
    />
  );
};
